export default "__VITE_ASSET__CQDQ1eQY__"